// Keep in sync with server/src/bucketApi/constants.ts
export const ALLOWED_FILE_TYPES = ["jpg", "jpeg", "png", "svg", "webp"];
export const FILE_SIZE_LIMIT = 50 * 1024 * 1024; // 50 MB
